module.exports = __webpack_public_path__ + "static/media/Ventilators.eb958757.png";